import * as Sentry from '@sentry/react';
import {useEffect} from 'react';
import {Routes, createRoutesFromChildren, matchRoutes, useLocation, useNavigationType} from 'react-router-dom';
import {WP_SENTRY} from '@/const';

const initSentryService = () => {
    if (!WP_SENTRY) return;

    Sentry.init({
        dsn: WP_SENTRY?.dsn || '',
        integrations: [
            Sentry.reactRouterV7BrowserTracingIntegration({
                useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes
            })
        ],
        tracesSampleRate: Number(WP_SENTRY?.tracesSampleRate || 1)
    });
};

const user = WP_SENTRY?.context?.user;
!!user && Sentry.setUser(user);

!!WP_SENTRY?.release && Sentry.setTag('release', WP_SENTRY?.release);
!!WP_SENTRY?.environment && Sentry.setTag('environment', WP_SENTRY?.environment);

const tags = WP_SENTRY?.context?.tags;
if (tags) {
    tags?.wordpress && Sentry.setTag('wordpress', tags?.wordpress);
    tags?.language && Sentry.setTag('language', tags?.language);
}

const SentryErrorBoundary = Sentry.ErrorBoundary;

const SentryRoutes = Sentry.withSentryReactRouterV7Routing(Routes);

const sentryRootOptions = {
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
        console.warn('Uncaught error', error, errorInfo.componentStack);
    }),
    onCaughtError: Sentry.reactErrorHandler(),
    onRecoverableError: Sentry.reactErrorHandler()
};

export default {initSentryService, SentryErrorBoundary, SentryRoutes, sentryRootOptions};
